import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

export interface InputDialogData {
  title: string;
  confirmBtnLabel: string;
  input: {
    name: string,
    description: string
  }
}

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent implements OnInit {

  inputForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: InputDialogData
  ) {
    this.inputForm = formBuilder.group({
      name: new FormControl(data.input?.name ?? '', Validators.required),
      description: new FormControl(data.input?.description ?? ''),
    });
  }

  ngOnInit(): void { }

  get result() {
    return { ...this.data, input: this.inputForm.value };
  }

}
